
import { controls } from "../controls";


const cnsearch = {
  label: "Customer Number Search",
  pageLabel: "Customer Number Search",
  starting: true,
  url: "cnsearch",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Customer Type", width: "col-sm-4" }),
    ...controls.select({
      tab: "filter", name: "customer_type", width: "col-sm-4", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Individual",
        value: "individual"
      },
      {
        label: "internal",
        value: "internal"
      },
      {
        label: "Other",
        value: "other"
      },
      ]
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-4" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch", width: "col-sm-4" }),
    ...controls.showData({ tab: "filter", data: "branch_display", width: "col-sm-2", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "cust_no", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", label: "Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "name", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "First Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "first_name", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "Last Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "last_name", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "No Of Record", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "Active", name: "isActive", width: "col-sm-6", default: true }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Customer Numbers",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "CIN",
        accessor: "cin",
        width: 150
      },
      {
        Header: "Name",
        accessor: "description",
      },
      {
        Header: "guid",
        show: false,
        accessor: "guid",
      }
    ]
  }
}

export default cnsearch;